import React from 'react';
import ButtonIcon from './ButtonIcon';

const IconMinus: React.FC<any> = () => {
    return (

        <ButtonIcon
            color={'lightgray'}
            size={'1.4rem'}
            icon={'fa-minus'}
            mask={'fa-square'}
            shrink={7}
        />
    );
};
export default IconMinus;